import { Injectable } from '@angular/core';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';
import { Observable } from 'rxjs';
import { CategoriaModel } from '../Modelo/Categoria.model';
import { CategoriaPrincipalModel } from '../Modelo/CategoriaPrincipal.model';

@Injectable({
    providedIn: 'root'
})
export class CategoriasService {

    constructor(
        private Utilidades: UtilidadesService
    ) { }

    public Lista(): Observable<CategoriaModel[]> {
        return this.Utilidades.Get("Categorias");
    }

    public ListaPrincipal(): Observable<CategoriaPrincipalModel[]> {
        return this.Utilidades.Get("Categorias/Principal");
    }
}